import { fulfilled, pending, rejected } from '../../../utils';
import { RESEND_EMAIL } from '../../actions/actiontype';

const initialState = {
	status: '',
	loading: false,
	message: '',
	data: '',
	error: '',
};

const resendEmailReducer = (state = initialState, action) => {
	switch (action.type) {
		case pending(RESEND_EMAIL):
			return {
				...state,
				loading: true,
				message: '',
				error: '',
			};
		case fulfilled(RESEND_EMAIL):
			return {
				...state,
				loading: false,
				status: action?.payload?.data?.status,
				message: action?.payload?.data?.message,
				data: action?.payload?.data?.data,
				error: '',
			};
		case rejected(RESEND_EMAIL):
			return {
				...state,
				loading: false,
				message: '',
				error: status ===500 ? "Something went wrong. Please try again later" : action?.payload?.response.data.message,
			};
		default:
			return state;
	}
};

export default resendEmailReducer;
